import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Text, useBreakpointValue, Icon, Circle, Flex } from '@chakra-ui/react';
import { CartContext } from '../../../context/cart';
import { AiOutlineShoppingCart } from 'react-icons/ai';
import { FiChevronRight } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const MotionBox = motion(Box);

export const FloatingButton = () => {
  const { cartPlans } = useContext(CartContext);
  const navigate = useNavigate();

  // Show only on desktop or defined breakpoints
  const isVisible = useBreakpointValue({ base: false, md: false, lg: true, xl: true });

  if (!isVisible || !cartPlans || cartPlans.length === 0) return null;

  const itemCount = cartPlans.length;

  return (
    <AnimatePresence>
      <MotionBox
        initial={{ opacity: 0, scale: 0.9, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.9, y: 20 }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => navigate('/cart')}
        position="fixed"
        bottom="40px"
        right="40px"
        zIndex={1000}
        cursor="pointer"
      >
        <Flex
          bg="linear-gradient(135deg, #0C727E 0%, #064e57 100%)"
          color="white"
          p={4}
          px={6}
          borderRadius="full"
          boxShadow="0 10px 30px rgba(12, 114, 126, 0.4)"
          alignItems="center"
          gap={4}
          transition="all 0.3s ease"
          border="1px solid rgba(255,255,255,0.1)"
          backdropFilter="blur(10px)"
        >
          <Box position="relative">
            <Icon as={AiOutlineShoppingCart} fontSize="24px" />
            <Circle
              size="20px"
              bg="red.500"
              color="white"
              position="absolute"
              top="-8px"
              right="-8px"
              fontSize="10px"
              fontWeight="bold"
              border="2px solid #0C727E"
            >
              {itemCount}
            </Circle>
          </Box>

          <VStack spacing={0} align="start" display={{ base: 'none', lg: 'flex' }}>
            <Text fontSize="md" fontWeight="bold" lineHeight="1.2">
              {itemCount} Health Check{itemCount > 1 ? 's' : ''}
            </Text>
            <Text fontSize="xs" opacity={0.8}>
             In your cart
            </Text>
          </VStack>

          <Icon as={FiChevronRight} fontSize="20px" ml={2} />
        </Flex>
      </MotionBox>
    </AnimatePresence>
  );
};

// Helper for layout
const VStack = ({ children, align = 'center', spacing = 0, ...props }) => (
  <Flex direction="column" align={align} gap={spacing} {...props}>
    {children}
  </Flex>
);
